var map = {
	"./Clocks/desktop.mp4": "q/Qy",
	"./Clocks/phone.mp4": "Bgpc",
	"./Glasses/desktop.mp4": "cPIP",
	"./Glasses/phone.mp4": "ckSc",
	"./GulpOfWater/desktop.mp4": "M7pc",
	"./GulpOfWater/phone.mp4": "1YWo",
	"./Magazine/desktop.mp4": "8pHE",
	"./Magazine/phone.mp4": "s8Sh",
	"./MagazineSpyglass/desktop.mp4": "uEYD",
	"./MagazineSpyglass/phone.mp4": "rA/R",
	"./Melon/desktop.mp4": "xtnB",
	"./Melon/phone.mp4": "Bwqu",
	"./Nails/desktop.mp4": "wp3y",
	"./Nails/phone.mp4": "jlqC",
	"./RoundMove/desktop.mp4": "jWVx",
	"./RoundMove/phone.mp4": "N4mA",
	"./Smena7/desktop.mp4": "SLT/",
	"./Smena7/phone.mp4": "0JSs",
	"./Sweeping/desktop.mp4": "tk8w",
	"./Sweeping/phone.mp4": "8Of5",
	"./Waving/desktop.mp4": "Kmlj",
	"./Waving/phone.mp4": "JlRt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XUXf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg \.mp4$
// module id = XUXf
// module chunks = 1